import Swiper, { autoHeight, EffectCoverflow, EffectFade, FreeMode, Mousewheel }from 'swiper';
import 'swiper/swiper.scss';
import 'swiper/modules/effect-coverflow/effect-coverflow.scss';
import 'swiper/modules/effect-fade/effect-fade.scss';
import 'swiper/modules/mousewheel/mousewheel.scss';
import 'swiper/modules/free-mode/free-mode.scss';

import { gsap, Power1 } from "gsap";

document.addEventListener('DOMContentLoaded', () => {
    window.development = () => {
        
        const dev = document.querySelector('#development'),
              mediaQuery = '(max-width: 768px)',
              mediaQueryList = window.matchMedia(mediaQuery),
              buttons = dev.querySelector('.js-buttons'),
              button = buttons.querySelectorAll('.swiper-slide'),
              desc = dev.querySelector('.js-desc');
        
        let start = 0;
        let swiper_btn;

        const thisIndex = function(elm) {
            let nodes = elm.parentNode.childNodes, node, i = 0, count = 0;
            while( (node = nodes.item(i++)) && node != elm ) {
                if( node.nodeType == 1 ) count++;            
            }
            return count;
        };

        const dropdown = () => {
            if (mediaQueryList.matches) {
                let _height,
                    _active_height = buttons.querySelector('.is-active').clientHeight;                
                    buttons.clientHeight > _active_height ? _height = _active_height : _height = 'auto';     
                
                gsap.to(buttons, {
                    height: _height,
                    duration: .25,
                    immediateRender: false,
                    ease: 'Power1.easeOut',
                    onComplete: () => {
                        buttons.clientHeight > _active_height ? buttons.classList.add('is-opened') : buttons.classList.remove('is-opened')
                    }
                })
                
                start != 0 ? window.runScroll('#development') : start = 1;                
            }
        }
        
        const swiper_desc = new Swiper(desc, {
            modules: [EffectFade],
            //autoHeight: true,
            allowTouchMove: false,
            effect: 'fade',
            speed: 400
        });
        
        const swiper_buttons = () => {
            
            const start = () => {
                swiper_btn = new Swiper(buttons, {
                    modules: [EffectCoverflow, FreeMode, Mousewheel],
                    effect: 'coverflow',
                    direction: 'vertical',
                    loop: true,
                    freeMode: true,
                    slideToClickedSlide: true,
                    grabCursor: true,
                    mousewheel: true,
                    centeredSlides: true,
                    slidesPerView: 5,
                    speed: 600,
                    coverflowEffect: {
                        rotate: 0,
                        stretch: 0,
                        depth: 0,
                        modifier: 0,
                        slideShadows: false
                   },
                   on: {
                    activeIndexChange: function (e) {
                        let idx = e.slides[e.activeIndex].dataset.id,
                            slide = desc.querySelectorAll('.swiper-slide');
                        
                        for (let i = 0; i < slide.length; i++) {
                            slide[i].dataset.id === idx ? swiper_desc.slideTo(thisIndex(slide[i])) : false;
                        }
                        dropdown();
                        },
                    },
                })
            }
            
            
           /*
 mediaQueryList.addEventListener('change', event => {
                event.matches ? swiper.destroy() : start();
            })
*/
    
            !mediaQueryList.matches ? start() : false;
        };        
        
        setTimeout(() => {
            swiper_desc.update();
        }, 100)        

        for (let i = 0; i < button.length; i++) {
            button[i].addEventListener('click', (e) => {
                if (mediaQueryList.matches) {
                    let idx = e.currentTarget.dataset.id,
                        active = buttons.querySelector('.is-active'),
                        slide = desc.querySelectorAll('.swiper-slide');
                        
                        for (let i = 0; i < slide.length; i++) {
                            slide[i].dataset.id === idx ? swiper_desc.slideTo(thisIndex(slide[i])) : false;
                        }
                        
//                    swiper_desc.slideTo(idx);
                    active ? active.classList.remove('is-active') : false;
                    e.currentTarget.classList.add('is-active');
                    dropdown();
                    e.preventDefault() ? e.preventDefault() : e.preventDefault = false;
                }
            })
        } 
        
        mediaQueryList.addEventListener('change', event => {
            if(event.matches) {
                swiper_btn.destroy();
                setTimeout(() => {
                    dropdown()                    
                }, 200);
            } else {
                buttons.removeAttribute('style')
                swiper_buttons();
            }
        })
        
        //swiper_buttons();
        !mediaQueryList.matches ? swiper_buttons() : false;
         mediaQueryList.matches ? dropdown() : false;
    }

}, false);
